import * as Animate from "react-reveal";
import { useEffect, useRef, useState } from "react";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";
import WorldMapImg from "../../../assets/images/png/world-map-faint-v1.png";
import LearnDoorImg from "../../../assets/images/png/african-tech-team.webp";
import HireDoorImg from "../../../assets/images/png/executive-leaders.webp";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "../../../components/svgs";

const HomeHeaderSection = () => {
  const bannerRef = useRef(null);
  const [bannerHeight, setBannerHeight] = useState(0);

  useEffect(() => {
    if (!bannerRef.current) return;

    const observer = new ResizeObserver(([entry]) => {
      setBannerHeight(entry.target.offsetHeight);
    });

    observer.observe(bannerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <header className="relative overflow-y-visible" id="top">
      <HeaderNavigation bannerHeight={bannerHeight} />

      <section className="relative overflow-x-hidden max-w-[1280px] mx-auto px-6 pt-16 md:pt-20 pb-9">
        <Animate.Fade bottom>
          <div className="relative isolate text-center max-w-6xl mx-auto mb-11 md:mb-14">
            <div className="home-hero-map" aria-hidden="true">
              <img src={WorldMapImg} alt="" />
              <span className="home-hero-map-route home-hero-map-route-one">
                <i />
              </span>
              <span className="home-hero-map-route home-hero-map-route-two">
                <i />
              </span>
              <span className="home-hero-map-route home-hero-map-route-three">
                <i />
              </span>
              <span className="home-hero-map-node home-hero-map-node-one" />
              <span className="home-hero-map-node home-hero-map-node-two" />
              <span className="home-hero-map-node home-hero-map-node-three" />
              <span className="home-hero-map-node home-hero-map-node-four" />
            </div>

            <p className="flex items-center font-poppins justify-center gap-3 text-primary text-sm font-extrabold tracking-[0.1em] uppercase mb-5">
              <span className="w-8 h-[3px] bg-secondary inline-block"></span>
              One platform for skills, talent and global work
            </p>

            <h1 className="text-primary font-poppins font-bold tracking-[-0.055em] leading-[1.04] text-4xl sm:text-5xl lg:text-[76px] mb-3">
              We Build Great{" "}
              <span className="relative z-0 inline-block box-decoration-clone bg-secondary text-primary px-3 md:px-4 py-0.5 md:py-1 rounded-xl md:rounded-2xl shadow-[14px_14px_0_0_#6941d8] md:shadow-[22px_22px_0_0_#6941d8] lg:shadow-[30px_30px_0_0_#6941d8] xl:shadow-none">
                Global Talents
              </span>{" "}
              <span className="relative inline-block lg:-top-2 xl:-top-3">
                That Global Companies
              </span>{" "}
              <span className="relative z-10 inline-block  bg-[#6941d8] text-white px-3 md:px-4 py-0.5 md:py-2 leading-tight rounded-xl md:rounded-2xl xl:-top-3 xl:-ml-18">
                Hire
              </span>
              .
            </h1>

            <p className="text-gray max-w-[900px] font-poppins mx-auto text-base md:text-lg leading-[1.75]">
              We build world-class people with{" "}
              <strong className="text-[#9a6500] font-extrabold">
                AI capabilities
              </strong>
              —and help global companies{" "}
              <strong className="text-[#6941d8] font-extrabold">
                find and hire them
              </strong>
              .
            </p>

            <div className="flex flex-col sm:flex-row flex-wrap justify-center items-center gap-3 mt-5">
              <Link
                to="/start"
                className="w-full sm:w-auto bg-primary text-white font-poppins rounded-xl min-h-[50px] px-6 inline-flex items-center justify-center gap-3 text-sm font-bold shadow-course-feature hover:-translate-y-0.5 transition-all"
              >
                Explore Programs{" "}
                <span aria-hidden="true">
                  <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
                </span>
              </Link>
              <Link
                to="/hire"
                className="w-full sm:w-auto border border-primary text-primary font-poppins rounded-xl min-h-[50px] px-6 inline-flex items-center justify-center gap-3 text-sm font-bold hover:bg-hire-tint-blue transition-all"
              >
                Hire Talent{" "}
                <span aria-hidden="true">
                  <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
                </span>
              </Link>
              <a
                href="#finder"
                className="w-full text-primary text-sm  font-poppins font-bold underline underline-offset-[5px] mt-1"
              >
                Not sure what to learn? Take our career quiz →
              </a>
            </div>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div className="relative grid md:grid-cols-3 gap-4">
            <a
              href="#programs"
              className="group relative min-w-0 md:col-span-2 bg-primary rounded-[28px] min-h-[430px] md:min-h-[500px] overflow-hidden shadow-course-feature-lg"
            >
              <img
                src={LearnDoorImg}
                alt="Illustrative African professionals learning through a practical project"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.025]"
              />
              <span
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(rgba(3,4,107,0.05) 20%, rgba(3,4,107,0.94) 100%)",
                }}
              />
              <div className="absolute z-10 bottom-6 left-6 right-6 md:bottom-8 md:left-9 md:right-9 max-w-[590px] text-white">
                <small className="text-secondary font-poppins tracking-[0.11em] text-sm font-extrabold">
                  FOR INDIVIDUALS
                </small>
                <h2 className="tracking-[-0.035em] font-poppins my-4 text-2xl md:text-[34px] font-semibold">
                  Build your career
                </h2>
                <p className="text-[#e2e7ff] mb-4  font-poppins leading-[1.7]">
                  Learn practical skills, work on real projects, receive
                  coaching and prepare for global opportunities.
                </p>
                <strong className="text-secondary inline-flex font-poppins items-center gap-2.5 text-sm">
                  Explore Programs{" "}
                  <span aria-hidden="true">
                    <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
                  </span>
                </strong>
              </div>
            </a>

            <span
              className="grid absolute font-poppins z-20 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 border-[5px] border-white bg-secondary text-primary w-14 h-14 rounded-full place-items-center text-sm font-extrabold"
              aria-hidden="true"
            >
              UT
            </span>

            <a
              href="#hire"
              className="group relative min-w-0 bg-primary rounded-[28px] min-h-[430px] md:min-h-[500px] overflow-hidden shadow-course-feature-lg"
            >
              <img
                src={HireDoorImg}
                alt="Illustrative hiring leaders reviewing talent for a growing team"
                className="absolute inset-0 w-full h-full object-cover object-[center_30%] transition-transform duration-300 group-hover:scale-[1.025]"
              />
              <span
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(rgba(3,4,107,0.05) 20%, rgba(3,4,107,0.94) 100%)",
                }}
              />
              <div className="absolute z-10 bottom-6 left-6 right-6 md:bottom-8 md:left-9 md:right-9 max-w-[580px] text-white">
                <small className="text-secondary font-poppins tracking-[0.11em] text-sm font-extrabold">
                  FOR COMPANIES
                </small>
                <h2 className="tracking-[-0.035em] font-poppins my-4 text-2xl md:text-[34px] font-semibold">
                  Build your team
                </h2>
                <p className="text-[#e2e7ff] mb-4 font-poppins leading-[1.7]">
                  Access verified professionals and the infrastructure to hire,
                  manage and pay them.
                </p>
                <strong className="text-secondary inline-flex font-poppins items-center gap-2.5 text-sm">
                  Find Talent{" "}
                  <span aria-hidden="true">
                    <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
                  </span>
                </strong>
              </div>
            </a>
          </div>
        </Animate.Fade>
      </section>
    </header>
  );
};

export default HomeHeaderSection;
